import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c(VBtn,_vm._g(_vm._b({style:('padding: unset!important; width: '+(_vm.width ? _vm.width : '40px;')),attrs:{"disabled":_vm.disabled,"id":_vm.id,"icon":"","height":_vm.width ? _vm.width :
    '38px'},on:{"click":function($event){return _vm.click()}}},'v-btn',attrs,false),on),[_c(VIcon,{style:(_vm.defineSize()),attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.icon))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }